import { compose, withPropsOnChange } from "recompose"

import { getPlannedDefects } from "../../api/entities/plannedDefects"
import withApiTransport from "../../api/apiTransport"

const enhance = compose(
  withPropsOnChange([`sapIssueId`], ({ sapIssueId }) => ({
    load: getPlannedDefects,
    propName: `plannedDefectsList`,
    payload: sapIssueId,
  })),
  withApiTransport,
)

export default enhance
